<template>
  <div class="thumbnails">
    <div
      class="thumbnails__nav-btn thumbnails__nav-btn--prev"
      @click="startScroll('up')"
      @touchend="stopScroll"
      @mouseup="stopScroll"
      v-if="isNavOn"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23">
        <path
          fill-rule="evenodd"
          fill="#A4B1C2"
          d="M19.633 19.632A11.425 11.425 0 0111.5 23c-3.072 0-5.96-1.196-8.132-3.368A11.423 11.423 0 010 11.5c0-3.073 1.196-5.961 3.368-8.132A11.425 11.425 0 0111.5 0C17.841 0 23 5.159 23 11.5c0 3.072-1.196 5.961-3.367 8.132zM11.5 2.165c-5.147 0-9.335 4.187-9.335 9.335 0 5.147 4.188 9.335 9.335 9.335 5.148 0 9.335-4.188 9.335-9.335 0-5.148-4.187-9.335-9.335-9.335zm4.229 8.673a1.11 1.11 0 01-.814.366 1.07 1.07 0 01-.699-.261l-1.633-1.397v6.311c0 .607-.476 1.083-1.083 1.083a1.071 1.071 0 01-1.082-1.083V9.546l-1.631 1.395a1.044 1.044 0 01-.705.272 1.07 1.07 0 01-1.069-1.098c0-.338.125-.624.363-.828L11.5 5.731l4.123 3.555c.464.392.513 1.072.112 1.546l-.006.006z"
        />
      </svg>
    </div>

    <ul class="thumbnails__list">
      <li
        class="thumbnails__item"
        v-for="(images, index) in gallery"
        :key="images.src"
      >
        <!-- <product-image
          :class="{ 'thumb-video': images.video }"
          :image="images"
          :alt="productName | htmlDecode"
          @click="navigate(index)"
        /> -->
        <product-image-cloudfront
          class="product-image__content off_style-b-m"
          :thumbnail-path="images.thumbnail_path"
          :thumbnail-size="'40'"
          :alt="productName | htmlDecode"
          @click="navigate(index)"
        />
      </li>
    </ul>
    <div
      class="thumbnails__nav-btn thumbnails__nav-btn--next"
      @click="startScroll('down')"
      @touchend="stopScroll"
      @mouseup="stopScroll"
      v-if="isNavOn"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23">
        <path
          fill-rule="evenodd"
          fill="#A4B1C2"
          d="M11.5 22.999c-3.072 0-5.96-1.196-8.132-3.367A11.425 11.425 0 010 11.5c0-3.073 1.196-5.961 3.368-8.133A11.428 11.428 0 0111.5 0c3.073 0 5.961 1.196 8.133 3.367A11.429 11.429 0 0123 11.5c0 6.341-5.159 11.499-11.5 11.499zm0-20.835c-5.147 0-9.335 4.188-9.335 9.336 0 5.147 4.188 9.335 9.335 9.335 5.148 0 9.335-4.188 9.335-9.335 0-5.148-4.187-9.336-9.335-9.336zm0 15.105l-4.124-3.556a1.054 1.054 0 01-.363-.828c0-.271.087-.518.252-.716.206-.244.503-.383.817-.383.261 0 .512.097.705.273l1.631 1.394V7.142A1.07 1.07 0 0111.5 6.06c.607 0 1.083.475 1.083 1.082v6.311l1.633-1.396a1.07 1.07 0 01.699-.261c.304 0 .601.133.814.365l.006.007c.401.474.352 1.153-.112 1.546L11.5 17.269z"
        />
      </svg>
    </div>
  </div>
</template>

<script>
import ProductImage from './ProductImage'
import ProductImageCloudfront from './ProductImageCloudfront'

export default {
  name: 'Thumbnails',
  components: {
    ProductImage,
    ProductImageCloudfront
  },
  props: {
    gallery: {
      type: Array,
      required: true,
      default: () => []
    },
    productName: {
      type: String,
      required: true
    }
  },

  data: () => {
    return {
      animationFrame: null
    }
  },

  computed: {
    isNavOn () {
      return this.gallery.length > 5
    }
  },

  methods: {
    navigate (index) {
      this.$emit('navigateTo', index)
    },
    animateScroll (timestamp, direction, el) {
      direction === 'down' ? (el.scrollTop += 102) : (el.scrollTop -= 102)
    },
    startScroll (direction) {
      const el = document.querySelector('.thumbnails__list')
      this.animationFrame = window.requestAnimationFrame(timestamp => {
        this.animateScroll(timestamp, direction, el)
      })
    },
    stopScroll () {
      this.animationFrame = window.cancelAnimationFrame(this.animationFrame)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~theme/css/animations/transitions';
@import '~theme/css/variables/colors';
@import '~theme/css/helpers/functions/color';
$color-gainsboro: color(gainsboro);
$color-white: color(white);

.thumbnails {
  display: none;
  position: relative;

  @media (min-width: 768px) {
    display: block;
    flex: 0 0 90px;
    margin: 0 20px 0 0;
    padding: 40px 0;
  }

  &__list {
    margin: 0;
    padding: 0;
    list-style: none;
    @media (min-width: 768px) {
      background: $color-white;
      height: 508px;
      overflow: auto;
      -ms-overflow-style: none;
      scrollbar-width: none;
      &::-webkit-scrollbar {
        display: none;
      }
    }
  }

  &__nav-btn {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    padding: 5px;
    cursor: pointer;

    svg {
      display: block;
    }

    &--prev {
      top: 0;
    }
    &--next {
      bottom: 0;
    }
  }

  &__item {
    border: 1px solid $color-gainsboro;
    margin-bottom: 2px;
  }
}
.off_style-b-m {
  mix-blend-mode: unset;
}
</style>
